@if (displayIcon()) {
  <mat-icon class="alert-icon material-symbols-outlined" inline="true">{{ alertIcon() }}</mat-icon>
}
<div class="alert-content">
  <ng-content></ng-content>
</div>
